/**
 * Retorna a profundidade de um nó específico dentro de uma hierarquia.
 * @param {Array|Object} data - Array de raízes ou um único nó raiz.
 * @param {any} targetValue - Valor único do nó procurado.
 * @param {string} childrenKey - Nome da propriedade que contém os filhos.
 * @param {string} idKey - Nome da propriedade que identifica unicamente cada nó.
 * @returns {number} - Profundidade (1 = raiz). Retorna 0 se não encontrado.
 */
function getDepthOfNode(data, targetValue, childrenKey, idKey) {
  if (!data) return 0;

  const roots = Array.isArray(data) ? data : [data];

  function search(node, depth) {
    if (!node || typeof node !== 'object') return 0;
    if (node[idKey] === targetValue) return depth;

    const kids = node[childrenKey];
    if (!Array.isArray(kids)) return 0;

    for (const child of kids) {
      const found = search(child, depth + 1);
      if (found) return found;
    }

    return 0;
  }

  for (const root of roots) {
    const result = search(root, 1);
    if (result) return result;
  }

  return 0; // não encontrado
}

export default getDepthOfNode;
